<template>
  <div class="page">
    <h1>有看投平台大咖服务协议</h1>
    <h2>甲方：上海第一财经传媒有限公司</h2>
    <h2>乙方：投资顾问/投资达人</h2>

    <p>
      本协议由投资顾问/投资达人作为乙方和有看投平台的经营者作为甲方共同缔结，具有合同效力。无论乙方事实上是否在注册之前认真阅读了本服务协议，只要乙方点击协议正文下方的“注册”按钮并按照有看投平台注册程序成功注册，乙方的行为仍然表示其同意并签署了本协议，并接受本协议各项规则的约束。在用户每次登录时也需勾选此服务协议。
    </p>

    <h2>1. 基本定义</h2>
    <ul>
      <li>
        1.1
        有看投平台：指甲方所有并实际运营的有看投APP平台包括但不限于手机端、pc端、小程序、微信公众号等（下简称“平台”或“有看投”）。
      </li>
      <li>
        1.2
        投资顾问：指同意并承诺遵守本协议规定，使用“有看投”向用户提供锦囊/课程/点金/直播产品服务的，具有证券投资咨询执业资格，并在中国证券业协会注册登记为证券投资顾问的执业人员。
      </li>
      <li>
        1.3
        投资达人：指同意并承诺遵守本协议规定，使用“有看投”向用户提供锦囊/课程/点金/直播产品观摩权的人员。投资达人具有一定的投资经验、市场声誉或者投资业绩，但不具有证券投资咨询执业资格。
      </li>
      <li>
        1.4
        投顾（投资达人）账户：是指乙方在平台上注册，用于向平台用户提供服务的小程序大咖端账户。
      </li>
      <li>
        1.5
        平台用户：指在甲方有看投平台上注册成为用户，使用有看投平台服务的个人。
      </li>
    </ul>

    <h2>2. 协议内容</h2>
    <ul>
      <li>
        2.1
        甲方向乙方开放有看投平台，乙方在有看投平台上注册实名账户，并向购买用户发布产品，包括但不限于点金、锦囊、课程、直播、会员等产品。锦囊产品主要是乙方的模拟盘操作的观摩权；乙方在有看投平台上发送音频、视频、文字等内容作为课程、点金观点等内容；乙方在有看投平台上开设直播间进行直播内容。若后续app开发新的产品线，此条协议内容同样有效。
      </li>
      <li>
        2.2
        乙方以投资顾问/投资达人身份在平台上提供服务。甲方平台的所有用户均可购买产品。乙方上线的产品价格由甲方运营决定。
      </li>
      <li>
        2.3 乙方提供投资顾问身份才可开通锦囊权限，投资达人身份不可开通锦囊权限。
      </li>
    </ul>
    <h2>3. 账户管理</h2>
    <ul>
      <li>
        <p>
          3.1
          乙方在服务平台上注册成为投资顾问/投资达人，应使用真实的个人信息资料。在后续使用平台服务的过程中，乙方应当及时更新自己的资料，以使之保持真实、及时，完整和准确。
        </p>
      </li>
      <li>
        <p>
          3.2
          乙方应当对自身账户和密码的安全负责，保持账户的专用性。除非根据法律规定或主管部门要求，且征得甲方的同意，否则，账户不得以任何方式转让、赠与或继承。如果发现任何人以不当方式使用乙方账户，甲方有权暂停相关服务。
        </p>
      </li>
    </ul>

    <h2>4. 双方的权利和义务</h2>
    <h3>4.1 乙方的权利和义务：</h3>
    <ul>
      <li>
        <p>
          4.1.1
          乙方应向甲方提供真实、合法、准确、有效的身份资料/资格证明资料。在相关资料实际变更时，乙方应及时更新有关注册资料。乙方不得以他人资料在服务平台上进行注册。
        </p>
      </li>
      <li>
        <p>
          4.1.2
          乙方在产品服务中的需遵守国家法律、法规以及各项规章制度的规定，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则的规定。因违反本条约定产生任何法律纠纷、诉讼或索赔的，由乙方自行独立解决并承担相关责任。
        </p>
      </li>
      <li>
        <p>
          4.1.3
          乙方应掌握证券投资、金融资本市场相关知识和技能，并具有丰富的投资实践经验，充分运用自己的专业知识、经验和技能，为平台用户提供服务。
        </p>
      </li>
      <li>
        <p>
          4.1.4
          乙方操作锦囊应使用第一财经“有看投”APP集成的模拟交易系统，也可使用“有看投”模拟交易网页版进行操作。登录账号密码唯一。
        </p>
      </li>
      <li>
        <p>
          4.1.5
          乙方不得故意使用系统漏洞，进行不当获利。对于由此带来的数据异常，平台方有权进行调整。
        </p>
      </li>
      <li>
        <p>
          4.1.6
          乙方上线锦囊产品时需要注明交易风格，适合资金规模，以供投资者自主选择。相应锦囊的操作也应和上线时的说明相一致。如有调整，需另做说明。乙方可以依照风格不同，上线2个锦囊产品，每个锦囊产品相互独立，单独计算收益率。
        </p>
      </li>
      <li>
        <p>
          4.1.7
          乙方上传的所有素材包括但不限于封面图、内页图、图片上的字体，文章的引用内容，所有素材确保无侵权行为，因违反相关知识产权的，引起第三方纠纷的，由素材上传方负责，由乙方自行独立解决并承担相关责任。
        </p>
      </li>
      <li>
        <p>
          4.1.8
          由于乙方上传的内容导致平台账号无法运营或关停的，如违反直播规定导致直播平台账号封禁或关停的，甲方有权向乙方追诉相应的赔偿。
        </p>
      </li>
      <li>
        <p>
          4.1.9
          乙方如果因为个人原因，无法继续上传服务内容，需要提前一个月告知甲方，以停止产品销售。
        </p>
      </li>
    </ul>

    <h3>4.2 甲方的权利和义务</h3>
    <ul>
      <li>
        <p>
          4.2.1
          甲方向乙方提供有看投平台，承诺在现有技术上维护服务平台的正常运行，并努力提升和改进技术，使乙方的产品服务得以顺利进行。
        </p>
      </li>
      <li>
        <p>
          4.2.2
          对乙方在注册或使用平台服务中所遇到的与服务或注册有关的问题及反映的情况，甲方应及时做出回复。
        </p>
      </li>
      <li>
        <p>
          4.2.3
          甲方有权对乙方的注册数据及服务行为进行查阅，发现注册数据或服务行为中存在任何问题，均有权向乙方发出询问或要求改正的通知，或者直接作出删除等处理。
        </p>
      </li>
      <li>
        <p>
          4.2.5 根据产品上线后的销售表现，甲方有权对相应产品的服务价格进行调整。
        </p>
      </li>
      <li>
        <p>
          4.2.6
          乙方在平台上所发布内容的知识产权归甲、乙双方共同所有。乙方在此授予甲方独家免费许可使用权（以及转授权的权利），甲方有权（全部或部份地）使用、复制、修订、改写、发布、展示乙方发表于网站的各类信息或制作其派生作品，或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内。
        </p>
      </li>
      <li><p>4.2.7 模拟交易规则由甲方制定，解释权归甲方所有。</p></li>
    </ul>

    <h2>5. 收益分成</h2>
    <ul>
      <li>
        <p>
          5.1
          甲方根据产品的实际收入扣除税金及手续费等成本后与乙方进行收益分成，其中，甲方占六成，乙方占四成，个别渠道的分成比例以双方实际约定为准。具体分成方案另行签订分成协议。
        </p>
      </li>
    </ul>

    <h2>6. 协议的生效、终止、期限及有效通知</h2>
    <ul>
      <li>
        <p>
          6.1
          本协议经乙方点击“注册后”后生效。除双方另有约定或本协议约定的终止条件发生，本协议将长期持续有效。
        </p>
      </li>
      <li>
        <p>
          6.2
          本协议内容包括协议正文及所有服务平台已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。乙方在使用服务平台提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。甲方有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，甲方将在相关平台上以公示形式通知乙方。如乙方不同意相关变更，必须立即以书面通知的方式终止本协议。任何修订和新规则一经在服务平台公布即自动生效，成为本协议的一部分。登录或继续使用产品服务将表示乙方接受经修订的协议。除另行明确声明外，任何使服务范围扩大或功能增强的新内容均受本协议约束。
        </p>
      </li>
      <li>
        <p>
          6.3
          本服务协议仅在乙方与甲方之间产生法律效力，并不涉及乙方与平台其它用户之间因产品服务而产生的法律关系及法律纠纷。乙方因在平台外发生纠纷，并影响乙方在本平台提供服务的，乙方有义务提前告知甲方。
        </p>
      </li>
      <li>
        <p>6.4 协议的终止：</p>
        <ul>
          <li>
            <p>6.4.1 通知解除：协议任何一方均可以提前一个月通知终止本协议。</p>
          </li>
          <li>
            <p>6.4.2 甲方单方解除权：</p>
            <ul>
              <li>
                <p>
                  ①如乙方违反甲方的任何规则或本协议中的任何承诺或保证，包括但不限于本协议项下的任何约定，如发现乙方恶意操作或长时间终止操作产品的以及遭受到用户投诉等，甲方都有权立刻终止本协议，并停止销售其对应的产品，且按有关规则对乙方进行处罚；甲方有权要求乙方赔偿其所有损失。
                </p>
              </li>
              <li>
                <p>
                  ②若乙方屡次违反本协议或相关规定，经甲方提醒仍不改正的；或因乙方的言行对甲方造成经济、名誉损失的，甲方有权终止与乙方的协议，并冻结乙方的账号等；甲方有权要求乙方赔偿其所有损失。
                </p>
              </li>
              <li>
                <p>
                  ③若乙方因上传的内容违反相关平台的规定包括但不限于侵权行为、发布违禁内容导致平台造成损失的，甲方有权终止与乙方的协议，并冻结乙方的账号等；甲方有权要求乙方赔偿其所有损失。
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              6.4.3 本协议规定的其他协议终止条件发生或实现，导致本协议终止。
            </p>
          </li>
        </ul>
      </li>
    </ul>

    <h2>7. 保密条款</h2>
    <ul>
      <li>
        <p>
          7.1
          本协议所称秘密信息包括但不限于双方在签署或履行本协议期间，一方获得的或收到的有关对方商务、财务、技术、产品等方面不为公众所知悉的信息。任何一方未经商业秘密提供方同意，均不得将该信息向任何第三方披露、传播、编辑或展示。协议方承诺，本协议终止后仍承担此条款下的保密义务，保密期将长期有效。
        </p>
      </li>
      <li>
        <p>
          7.2
          因对方书面同意以及国家行政、司法强制行为而披露商业秘密的，披露方不承担责任；该商业秘密已为公众所知悉的，披露方不承担责任。
        </p>
      </li>
    </ul>

    <h2>8. 不可抗力</h2>
    <ul>
      <li>
        <p>
          8.1
          本协议签订后，任何一方由于受火灾、旱灾、台风、大雪、地震、战争或政策法规调整等不可预见、不能避免并不能克服的事件（即不可抗力事件）影响而不能全部或部分履行其在本协议项下义务的，可根据其受不可抗力事件影响的情况而部分或全部免于承担违约责任。
        </p>
      </li>
      <li>
        <p>
          8.2
          受不可抗力事件影响的一方应尽快将不可抗力事件的发生及其受之影响全部通知对方，并在合理期限内向对方提供相关权威机构出具的有关不可抗力事件发生的书面证明。
        </p>
      </li>
    </ul>

    <h2>9. 违约及违约责任</h2>
    <ul>
      <li>
        <p>9.1 违约：发生下列任何一个或多个事件都将构成对本协议的违约：</p>
        <ul>
          <li>
            <p>
              9.1.1
              任何一方实质性违反本协议的条款，或未能在任一实质方面履行其在本协议项下的义务，且在收到另一方要求补救的书面通知后10日内未能补救上述违约或不履约行为；或者
            </p>
          </li>
          <li>
            <p>
              9.1.2
              任何一方在本协议项下的承诺、声明或保证在任一实质方面被证明是虚假或具有误导性的。
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          9.2
          违约责任：若任一方违反本协议，其应就其违约行为对另一方造成的任何及全部损失承担赔偿责任，但间接损害除外。
        </p>
      </li>
    </ul>

    <h2>10. 争议解决及其它</h2>
    <ul>
      <li>
        <p>
          10.1
          本协议之签署、效力、解释、履行及争议的解决均应适用中华人民共和国（不包括香港、澳门特别行政区及台湾地区）法律。
        </p>
      </li>
      <li>
        <p>
          10.2
          因本协议而产生或与之相关的任何争议，均应首先由双方友好协商解决。协商不成的，任何一方均有权向甲方所在地有管辖权的人民法院提起诉讼。
        </p>
      </li>
      <li>
        <p>
          10.3
          如果本协议一项条款全部或部份被视为无效或不具有执行，其它条款继续有效。
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UserAggrementBig',
  head: {
    title: '有看投平台大咖服务协议'
  }
}
</script>

<style>
body {
  background-color: #ffffff;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 15px 30px;
  max-width: 640px;
  margin: 0 auto;
  font-size: 30px;
}

h1 {
  font-weight: bold;
  font-size: 36px;
  padding: 10px 0;
}

h2 {
  font-weight: bold;
  font-size: 34px;
  margin: 15px 0;
}

h3 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}
p {
  text-indent: 2em;
}

ul {
  text-indent: 2em;
}
li {
  list-style: none;
}
</style>
